import { render, staticRenderFns } from "./form-code.vue?vue&type=template&id=730b9a49&"
import script from "./form-code.vue?vue&type=script&lang=js&"
export * from "./form-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports